import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["objectTypeDefinitions"];
import { useMemo } from 'react';
import { useObjectTypeDefinitions } from './useObjectTypeDefinitions';
export const useObjectTypeDefinition = objectTypeId => {
  const _useObjectTypeDefinit = useObjectTypeDefinitions(),
    {
      objectTypeDefinitions
    } = _useObjectTypeDefinit,
    rest = _objectWithoutPropertiesLoose(_useObjectTypeDefinit, _excluded);
  const objectTypeDefinition = useMemo(() => objectTypeDefinitions.find(definition => definition.objectTypeId === objectTypeId), [objectTypeDefinitions, objectTypeId]);
  return Object.assign({
    objectTypeDefinition
  }, rest);
};